// Variant modal slider index
var slideIndex = 1;

var recurateModal = (function($) {
  $body = $('body');
  var init = function() {
    // cache body selector
    $body = $('body');
  };

  var toggleModal = function(id) {
    // toggle classes
    if($body.hasClass('recurate-body-modal-open')) {
      close(id);
    } else {
      show(id);
    }
  };

  var show = function(id) {
    // add modal open class
    $body.addClass('recurate-body-modal-open');

    // set timeout for active class to allow css animation
    setTimeout(function() {
      $(id).addClass('recurate-modal-active');
      if($(id + " .rec-var-images-modal").hasClass("rec-slider")) {
        $(id + " .rec-var-images-modal").slick("setPosition");      
        $(id + " .rec-var-images-modal").addClass("slick-loaded");        
      }
    },25);
  }

  var close = function(id) {
    // remove modal open class
    $body.removeClass('recurate-body-modal-open');
    // set timeout for active class to allow css animation
    setTimeout(function() {
      $('.recurate-modal').removeClass('recurate-modal-active');
    },25);
    // reset the slide index
    slideIndex = 1;
  };

  return {
    init: init,
    toggleModal: toggleModal,
    show: show,
    close: close
  };
}($rec));

//Custom JS Functionality
Shopify.queryParams = Shopify.queryParams || {};
if (Object.keys(Shopify.queryParams).length == 0 && location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
(function($) {

  var recurateVariantListInit = function() {

    $(document).keyup(function(e) {
      if (e.key === "Escape" && $("body.recurate-body-modal-open").length > 0) {
        recurateModal.close("");
     }
    });
    $("body").on("click",".recurate-modal-toggle", function(e) {
      e.preventDefault();
      recurateModal.toggleModal($(this).data("recurateModal"));
    });
    $("body").on("click",".recurate-modal-show", function(e) {
      e.preventDefault();
      recurateModal.show($(this).data("recurateModal"));
    });
    $("body").on("click",".recurate-modal-close", function(e) {
      e.preventDefault();
      recurateModal.close("");
    });
    $("body").on("click",".rec-condition-description-toggler", function(e) {      
      $(this).closest(".rec-var-option").children(".rec-condition-description-toggle").toggle();
    });

    var slidersInit = function() {    

      $('.rec-var-images.rec-slider').on('init', function(event, slick, currentSlide, nextSlide){
        $(this).addClass("slick-loaded");
      });
  
      //Variant Image Sliders
      $(".slider-pending").removeClass("slider-pending");
      $('.rec-var-images.rec-slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        infinite: true,
        swipeToSlide: true,
        prevArrow: '<div class="rec-hidden slick-prev slick-arrow-svg" tabindex="0"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="rec-hidden slick-next slick-arrow-svg" tabindex="0"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        responsive: [        
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false
            }
          }      
        ]
      });
      
      $('.rec-var-images-modal.rec-slider').slick({
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        focusOnSelect: true,
        swipeToSlide: true,
        infinite: true,
        prevArrow: '<div class="slick-prev slick-arrow-svg" tabindex="0"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="slick-next slick-arrow-svg" tabindex="0"><svg width="20" height="20" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5442 1.86047L6.6582 6.97675L1.7722 1.86047" stroke="#333132" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'      
      });    

      var $carousel = $('.rec-var-images-modal.rec-slider');
      $(document).on('keydown', function(e) {
        if(e.keyCode == 37) {
            $carousel.slick('slickPrev');
        }
        if(e.keyCode == 39) {
            $carousel.slick('slickNext');
        }
      });
  
      $(".rec-variant").hover(function() {
        $(this).find(".slick-arrow-svg").removeClass("rec-hidden");
      },
      function() {
        $(this).find(".slick-arrow-svg").addClass("rec-hidden");
      });
    };  
  
    //filtering
    var refilter = function() {
      $(".rec-variant-none").addClass("rec-hidden");
      $(".rec-variant").removeClass("filtered-data-size filtered-data-color filtered-data-condition");
      if($(".rec-filter li.active").length > 0) {
        $(".rec-variant").addClass('rec-hidden');
        var attr;
        $(".rec-filter").each(function() {
          attr = $(this).data('attr');        
          if($(this).children("li.active").length > 0) {
            $(this).children("li.active").each(function() {                  
              $(".rec-variant["+attr+"='" + $(this).data('val') + "']").addClass("filtered-" + attr);
            });
          } else {
            $(".rec-variant").addClass("filtered-" + attr);
          }
        });         
        $(".rec-variant.filtered-data-size.filtered-data-color.filtered-data-condition").removeClass("rec-hidden");
        if($(".rec-variant:visible").length == 0) {
          $(".rec-variant-none").removeClass("rec-hidden");
        }
      } else {
        $(".rec-variant").removeClass('rec-hidden');
      }    
      if(window.innerWidth <= 768 && $(".rec-filtering-inner").hasClass("view")) {
        $('.rec-filtering h2').click();
        window.scrollTo(0,0);
      }
    }
    $('.rec-filter li').click(function() {
      $(this).toggleClass("active");
      refilter();
    });
    if(window.innerWidth <= 768) {
      $('.rec-filtering h2').click(function() {      
        $(".rec-filtering .collapse").toggleClass("rotate");
        $(".rec-filtering-inner").toggleClass("view");
      });
    }
  
    //sorting
    var resort = function(asc) {    
      $('.rec-var-images.rec-slider.slick-initialized').removeClass("slick-loaded");
      $('.rec-var-images.rec-slider.slick-initialized').slick('unslick');    
      $('.rec-var-images-modal.rec-slider.slick-initialized').removeClass("slick-loaded");
      $('.rec-var-images-modal.rec-slider.slick-initialized').slick('unslick');    
      var divList = $(".rec-variant");
      divList.sort(function(a, b){
          return asc?$(a).data("price")-$(b).data("price"):$(b).data("price")-$(a).data("price")
      });
      $(".rec-variant").remove();
      $(".rec-variant-none").removeClass("rec-hidden");
      $(".rec-variants").append(divList);

      if($(".rec-variant:visible").length > 0) {
        $(".rec-variant-none").addClass("rec-hidden");
      }

      slidersInit();    
      if(window.innerWidth <= 768 && $(".rec-filtering-inner").hasClass("view")) {
        $('.rec-filtering h2').click();
        window.scrollTo(0,0);
      }      
    }
    $('#rec-sort').on("change", function() {
      resort($(this).val()=="price-asc");
    });    

    //ok, go ahead and display things in the right initial sort order    
    resort(true);    

    //simple, native add to cart functionality
    $("body").on("click", ".recurate-cart-add", function(e) {
      e.preventDefault();
      var $btn = $(this);
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: $btn.data('id'),
          quantity: 1
        },
        success: function(item) {
          document.location = $btn.data('dest');
        },
        dataType: "json"
      });
    });

    //click on any actively selected variant
    $('.variant-select.selected').click();
  };

  //function to handle logic on used collections
  var recurateCollectionInit = function() {
    
  };  

  //do we see the Recurate code? If so, init the PDP
  if($(".recurate-variant-list").length > 0) {
    recurateVariantListInit();
  } else if($(".recurate-collection-item").length > 0) {
    recurateCollectionInit();
  }
  
})($rec);